import React, { Fragment, useEffect, useState } from 'react';
import { Row, Table, Button } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import Modal from '@material-ui/core/Modal';
import ModalUI from '../../../../shared/components/Modal';
import { calculateAgeParse } from '../../../Utils/Patient';

const no_op = () => { };
const FallingRisk = ({ data, openRisk, setOpenRisk, callbackFallingRisks = no_op }) => {

  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(false);

  const [caidasPrev, setCaidasPrev] = useState({ question: 'Caidas previas', options: ['Sí', 'No'], answer: '' });
  const [medicamentos, setMedicamentos] = useState({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: '' });
  const [deficits, setDeficits] = useState({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: '' });
  const [mental, setMental] = useState({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: '' });
  const [deambulacion, setDeambulacion] = useState({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: '' });
  const [onEdit, setOnEdit] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [modalAlert, setModalAlert] = useState({ title: '', color: '', message: '' });
  const [id_admision, setId_admision] = useState('');
  const [currentStateRisk, setCurrentStateRisk] = useState('');


  useEffect(() => {
    setLoading(true);
    if (data !== undefined && data.hasOwnProperty('riesgo_caidas')) {
      if (typeof data.riesgo_caidas !== '{}') {
        setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: data.riesgo_caidas.caida_previa });
        setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: data.riesgo_caidas.medicamentos });
        setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: data.riesgo_caidas.def_sensoriales })
        setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: data.riesgo_caidas.estado_mental });
        setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: data.riesgo_caidas.deambulacion });
        setCurrentStateRisk(data.riesgo_caidas.riesgo);
        setLoading(false);
        setOnEdit(true);
      }
    } 
    if (data !== undefined && data.hasOwnProperty('caidas')) {
      if (typeof data.caidas !== '{}') {
        setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: data.caidas.caida_previa });
        setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: data.caidas.medicamentos });
        setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: data.caidas.def_sensoriales })
        setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: data.caidas.estado_mental });
        setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: data.caidas.deambulacion });
        setCurrentStateRisk(data.caidas.riesgo);
        setLoading(false);
        setOnEdit(true);
      }
    } 
    setId_admision(data.id_admision)
    //loadFallingRisk(data);

  }, []);

  useEffect(() => {
    defineRisk();
  }, [caidasPrev.answer, medicamentos.answer, deficits.answer, mental.answer, deambulacion.answer])


  const loadFallingRisk = (data) => {
    var data = {
      id_historia: parseInt(data.original.id_historia),
      id_admision: parseInt(data.original.id_admision)
    };

    console.log(data);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'caida/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);

        if (data.contenido[0].caidas != null) {
          setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: data.contenido[0].caidas.caidas.caida_previa });
          setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: data.contenido[0].caidas.caidas.medicamentos });
          setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: data.contenido[0].caidas.caidas.def_sensoriales })
          setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: data.contenido[0].caidas.caidas.estado_mental });
          setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: data.contenido[0].caidas.caidas.deambulacion });
          setLoading(false);
          setDisable(true);

        }
        else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const defineRisk = () => {
    let valor = 0;
    let riesgo;

    if (caidasPrev.answer === 'Sí')
      valor = valor + 1;

    if (medicamentos.answer === 'Sí')
      valor = valor + 1;

    if (deficits.answer === 'Alteraciones Visuales, Auditivas')
      valor = valor + 1;

    if (mental.answer === 'Confuso')
      valor = valor + 1;

    if (deambulacion.answer === 'No')
      valor = valor + 1;

    if (valor >= 3) {
      riesgo = "Alto";
    } else if (valor == 2) {
      riesgo = "Medio";
    } else {
      riesgo = "Bajo";
    }

    setCurrentStateRisk(riesgo);
    return { riesgo, valor }
  }

  const updateFallingRisk = async () => {
    const { riesgo, valor } = defineRisk();

    setCurrentStateRisk(riesgo);
    let caidas = {
      caida_previa: caidasPrev.answer,
      medicamentos: medicamentos.answer,
      def_sensoriales: deficits.answer,
      estado_mental: mental.answer,
      deambulacion: deambulacion.answer,
      valor: valor,
      riesgo: riesgo,
      fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
    }

    let data = {
      id_admision: parseInt(id_admision),
      caidas,
    }

    console.log('dataFALLING', data);
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/actualizar-riesgo-caida', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        }
        else {
          throw new Error(response.json());
        }
      })
      .then(data => {
        console.log('data', data);
        callbackFallingRisks(id_admision, data.caidas);
        setOpenAlert(true);
        setModalAlert({ title: "Riesgo de Caida", message: "Riesgo de Caida actualizada con éxito", color: "success" })
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }



  const createFallingRisk = (data) => {
    let valor = 0;
    let riesgo;

    if (caidasPrev.answer === 'Sí')
      valor = valor + 1;

    if (medicamentos.answer === 'Sí')
      valor = valor + 1;

    if (deficits.answer === 'Alteraciones Visuales, Auditivas')
      valor = valor + 1;

    if (mental.answer === 'Confuso')
      valor = valor + 1;

    if (deambulacion.answer === 'No')
      valor = valor + 1;

    if (valor >= 3) {
      riesgo = "Alto";
    } else if (valor == 2) {
      riesgo = "Medio";
    } else {
      riesgo = "Bajo";
    }

    var data = {
      id_historia: parseInt(data.original.id_historia),
      id_admision: parseInt(data.original.id_admision),
      caidas: {
        caida_previa: caidasPrev.answer,
        medicamentos: medicamentos.answer,
        def_sensoriales: deficits.answer,
        estado_mental: mental.answer,
        deambulacion: deambulacion.answer,
        valor: valor,
        riesgo: riesgo,
        fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
      }
    };

    console.log(data);
    fetch(process.env.REACT_APP_PUBLIC_URL + 'caida/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.text();
      })
      .then(data => {
        console.log(data);
        setDisable(true);
        alert("Datos Guardados Correctamente");
        setOpenRisk(false);
        //this.setState({ disabled: true });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const onOkModal = () => {
    setOpenAlert(!openAlert),
      openRisk(false);
  }


  return (
    <Fragment>
      {loading ?
        <Modal
          open={openRisk}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div style={{
            position: 'absolute',
            backgroundColor: '#ffffff',
            width: 200,
            height: 200,
            backgroundColor: 'white',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            display: 'flex'
          }}
          >
            <div className="load__icon-wrap">
              <svg className="load__icon">
                <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
              </svg>
            </div>
          </div>
          {/*<div class="load">
                                   <div class="load__icon-wrap">
                                     <svg class="load__icon">
                                       <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"/>
                                     </svg>
                                   </div>
                                 </div>*/}
        </Modal> :
        <Modal
          open={openRisk}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}>

          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
            <div className="card__title">
              <h4 className="bold-text">Determinación de riesgo de caida </h4>
            </div>
            <Row>
              <div className="form" style={{ flexDirection: 'column' }}>
                <div className="half">
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div>
                      <h4>Información del paciente </h4>
                    </div>
                    <div>
                      <h5>Riesgo: <b>{currentStateRisk}</b> </h5>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, marginBottom: 10 }}>
                    {data != null ?
                      <div style={{ display: 'flex' }}>
                        <div style={{ paddingRight: 10 }}><h4><b>N° Admisión</b> {data.id_admision}</h4></div>
                        <div style={{ marginRight: 10 }}><h4><b>Documento: </b>{data.tip_documento}-{data.num_documento}</h4></div>
                        <div style={{ marginRight: 10 }}><h4><b>Nombre: </b>{data.fullname}</h4></div>
                        <div style={{ marginRight: 10 }}><h4><b>Edad: </b>{calculateAgeParse(data.birthday)}</h4></div>
                      </div> : null}
                  </div>
                  <div>
                    <Table style={{ height: 70, margin: 0 }}>
                      <tbody>
                        <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                          <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{caidasPrev.question}</td>
                          <td style={{ padding: 2 }}>

                            <FormControl component="fieldset" >
                              <RadioGroup
                                aria-label="Medicamentos"
                                name="medicamentos"
                                value={caidasPrev.answer}
                                onChange={e => {
                                  setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: e.target.value });
                                }}
                              >
                                <FormControlLabel value={caidasPrev.options[0]} control={<Radio color="primary" disabled={disable} />} label={caidasPrev.options[0]} />
                                <FormControlLabel value={caidasPrev.options[1]} control={<Radio color="primary" disabled={disable} />} label={caidasPrev.options[1]} />
                              </RadioGroup>
                            </FormControl>
                          </td>
                        </tr>
                        <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                          <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{medicamentos.question}</td>
                          <td style={{ padding: 2 }}>

                            <FormControl component="fieldset" >
                              <RadioGroup
                                aria-label="Medicamentos"
                                name="medicamentos"
                                value={medicamentos.answer}
                                onChange={e => {
                                  setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: e.target.value });
                                }}
                              >
                                <FormControlLabel value={medicamentos.options[0]} control={<Radio color="primary" disabled={disable} />} label={medicamentos.options[0]} />
                                <FormControlLabel value={medicamentos.options[1]} control={<Radio color="primary" disabled={disable} />} label={medicamentos.options[1]} />
                              </RadioGroup>
                            </FormControl>
                          </td>
                        </tr>
                        <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                          <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{deficits.question}</td>
                          <td style={{ padding: 2 }}>

                            <FormControl component="fieldset" >
                              <RadioGroup
                                aria-label="Medicamentos"
                                name="medicamentos"
                                value={deficits.answer}
                                onChange={e => {
                                  setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: e.target.value });
                                }}
                              >
                                <FormControlLabel value={deficits.options[0]} control={<Radio color="primary" disabled={disable} />} label={deficits.options[0]} />
                                <FormControlLabel value={deficits.options[1]} control={<Radio color="primary" disabled={disable} />} label={deficits.options[1]} />
                              </RadioGroup>
                            </FormControl>
                          </td>
                        </tr>
                        <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                          <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{mental.question}</td>
                          <td style={{ padding: 2 }}>

                            <FormControl component="fieldset" >
                              <RadioGroup
                                aria-label="Medicamentos"
                                name="medicamentos"
                                value={mental.answer}
                                onChange={e => {
                                  setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: e.target.value });
                                }}
                              >
                                <FormControlLabel value={mental.options[0]} control={<Radio color="primary" disabled={disable} />} label={mental.options[0]} />
                                <FormControlLabel value={mental.options[1]} control={<Radio color="primary" disabled={disable} />} label={mental.options[1]} />
                              </RadioGroup>
                            </FormControl>
                          </td>
                        </tr>
                        <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                          <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{deambulacion.question}</td>
                          <td style={{ padding: 2 }}>

                            <FormControl component="fieldset" >
                              <RadioGroup
                                aria-label="Medicamentos"
                                name="medicamentos"
                                value={deambulacion.answer}
                                onChange={e => {
                                  setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: e.target.value });
                                }}
                              >
                                <FormControlLabel value={deambulacion.options[0]} control={<Radio color="primary" disabled={disable} />} label={deambulacion.options[0]} />
                                <FormControlLabel value={deambulacion.options[1]} control={<Radio color="primary" disabled={disable} />} label={deambulacion.options[1]} />
                              </RadioGroup>
                            </FormControl>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button
                        color="primary"
                        disabled={disable}
                        style={{ marginTop: 10, marginRight: 10 }}
                        onClick={() => {
                          if (onEdit) {
                            updateFallingRisk();
                          } else {
                            createFallingRisk(data)
                          }
                        }}>
                        {onEdit ? 'Actualizar' : 'Guardar'}
                      </Button>
                      <Button
                        style={{ marginTop: 10 }}
                        color="primary"
                        onClick={() => {
                          setOpenRisk(false);
                        }}
                      >
                        Cerrar
                      </Button>
                    </div>

                  </div>
                </div>
              </div>
            </Row>
          </div>
        </Modal>}
      {openAlert ?
        <ModalUI
          color={modalAlert.color}
          title={modalAlert.title}
          message={modalAlert.message}
          modal={openAlert}
          toggle={() => { setOpenAlert(!openAlert) }}
          onOk={() => onOkModal()}
        /> : null}
    </Fragment>
  );




}

export default reduxForm({
  form: 'falling_risk_form', // a unique identifier for this form
})(withTranslation('common')(FallingRisk));